(function ($) { 

	var _currentGroupUuid = 0;

  	Drupal.behaviors.applicationFormChecks = {
		attach: function (context) {

			if($("#edit-group-uuid").length > 0 && $("#edit-group-uuid").val() != ""){
				_currentGroupUuid = $("#edit-group-uuid").val();
				Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormChecks() _currentGroupUuid:" + _currentGroupUuid);
			}
			if($("#applicationFormGroupName").length > 0 && $("#applicationFormGroupName").html() != ""){
				_currentGroupName = $("#applicationFormGroupName").html();
				Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormChecks() _currentGroupName:" + _currentGroupName);
			}

			$(".applicationFormCheckTextField", context).each(function (index){
				Drupal.behaviors.applicationFormChecksTextField(this);
			});
		}
  	}
  
  	Drupal.behaviors.applicationFormChecksTextField = function (context) {

		$(context).each(function (index){
			var mainContent = this;
		  	var isAlreadyModified = $(mainContent).data("saph-done");
		  	if(isAlreadyModified){
		  		return true;
		  	}
		  	
		  	var pathToCheck = $(mainContent).data("path-to-check");
			  
			$( mainContent ).focusout(function() {
				
				var value = $(".formField-textField-input",mainContent).val();
				Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormChecksTextField() value:" + value);

				if ($(".formField-textField-input",mainContent).val().length >= 0) {				
					
					//Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormChecksTextField() Calling ajax for check field...");
					
					if($(".formField-textField-input",mainContent).attr("id") == "edit-group-uuid" && $(".formField-textField-input",mainContent).val() == _currentGroupUuid){
						//do not vaildate field if group id is set to saved value
						//Drupal.behaviors.functions.consolog("group id is ok! no need to validate!");

						$(".formField", mainContent).removeClass("formField-error");
						$(".error-text-section", mainContent).remove();
						$("#applicationFormGroupName").html(_currentGroupName);

						return;
					}

					$.post(
						pathToCheck, 
						{value: $(".formField-textField-input",mainContent).val()},
						function(data, status){
							Drupal.behaviors.functions.consolog("Data: " + data + "\nStatus: " + status);

							$(".error-text-section", mainContent).remove();
							Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormChecksTextField() success! (data.success:" + data.success + ")");

							if(status == "success"){
								if(data.success == true){
									
									//everything is fine...
									Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormChecksTextField() everything is fine...");

									//show groupname if group id validation is ok
									if($(".formField-textField-input",mainContent).attr("id") == "edit-group-uuid"){
										var groupName = data.data[0].name;
										Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormChecksTextField() groupName:" + groupName);
										$("#applicationFormGroupName").html(groupName);																			
									}
								}
								else{
									//Show error messages
									$(".error-text-section", mainContent).remove();
									for (var i = 0; i < data.messages.length; i++) {
										var element = data.messages[i];
										var errorCode = data.messages[0].code;
										var errorText = $(mainContent).data("error-text-" + errorCode);
										if(errorText && errorText != ""){										
											$(".formField", mainContent).append('<div class="error-text-section formField-error-message" style="display:block;">' + errorText + '</div>');
											$(".formField", mainContent).removeClass("formField-error");
											$(".formField", mainContent).addClass("formField-error");		
										}
									}
								}
							}
							else{
								Drupal.behaviors.functions.consolog("Drupal.behaviors.applicationFormChecksTextField() error! (" + status + ")");														
							}
						}
					);
				}
			});
		      		  	
		  	$(mainContent).data("saph-done",true);
		});
  	}
})(jQuery);